import {createSelector} from 'helpers';

export const categories = createSelector(() => ({
  'work-&-career': 'Work & Career',
  'love-&-relationships': 'Love & Relationships',
  'health-&-fitness': 'Health & Wellness',
  'wealth-&-finances': 'Money & Finances',
  'family-&-friends': 'Family & Friends',
  'contribution': 'Recreation & Lifestyle',
  'spiritual-life': 'Spirituality & Faith',
  'personal-development': 'Personal Growth',
  'other': 'Other Goals',
}));
